export default __webpack_public_path__ + "static/media/KFC.17e929c5.gif";